import React, {
  useState,
  useContext,
  useEffect,
}                           from 'react';
import { historyPropType }  from '~/config/routerPropTypes';
import { showAddon }        from '~/config/routes';
import Request              from '~/providers/Request';
import Addon                from './context';
import AddonRecord          from '~/records/AddonRecord';
import Form                 from './Form';

function EditRecord({history}){
  const [ record, setRecord] = useState(new AddonRecord());
  const [ loading, setLoading] = useState(false);
  const { records, addRecords } = useContext(Addon);
  const { id } = history.location.route.getParams();

  useEffect(() => {
    async function fetchData(id){
      if(records && records[id]){
        record.updateAttributes(records[id]);
      }

      setLoading(true);
      Request.get(`/admin/packages/${id}`, {})
        .then( response => {
          setLoading(false);
          addRecords({ data: [response.data] }); //Array para reusar o util de transformar e jogar no contexto.
          setRecord( record.updateAttributes(response.data) );
        })
        .catch( e => {
          console.error(e);
          setLoading(false);
        });
    }
    fetchData(id);
  }, []);

  async function onSubmit (){
    const data = record.toParams();
    setLoading(true);
    Request.put(`/admin/packages/${id}`, data, {}, { controller: 'addon' })
    .then((e) => {
      setLoading(false);
      history.push(showAddon.reverse(e.data));
    })
    .catch(e => {console.error(e); setLoading(false);});
  }

  const handleChange = (attrs) => {
    setRecord( record.updateAttributes(attrs) );
  };

  return(
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
      setRecord={setRecord}
    />
  );
}

EditRecord.propTypes={
  history: historyPropType,
};

export default EditRecord;
